import {
  encrypt,
  decrypt
} from 'crypto-js/aes'
import UTF8, {
  parse
} from 'crypto-js/enc-utf8'
import pkcs7 from 'crypto-js/pad-pkcs7'
import ECB from 'crypto-js/mode-ecb'

export const cacheCipher = {
  key: parse('_AIXIAODOUCN_CRYPTO_KEY@'),
  iv: parse('@AIXIAODOUCN_CRYPTO_IV_')
}

function getOptions () {
  return {
    mode: ECB,
    padding: pkcs7,
    iv: cacheCipher.iv
  }
}

export function encryptByAES (cipherText) {
  return encrypt(cipherText, cacheCipher.key, getOptions()).toString()
}
export function decryptByAES (cipherText) {
  const res = decrypt(cipherText, cacheCipher.key, getOptions()).toString(UTF8)
  try {
    return JSON.parse(res)
  } catch (e) {
    return res
  }
}

// 是否开启AES加密
export const allowAES = process.env.NODE_ENV !== 'development'



// WEBPACK FOOTER //
// ./src/utils/cipher.js